import { useQuery } from "@tanstack/react-query";
import { spbTransferAPI } from "../spbTransferAPI.ts";

export const useGetSbpTransferAvailableTermsQuery = () => {
  return useQuery ({
    queryKey: ["sbp-transfer-available-terms"],
    queryFn: () => spbTransferAPI.getAvailableTerms(),
    staleTime: 5 * 60 * 1000, // 5мин
    gcTime: 15 * 60 * 1000, // 15мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
